<template>
    <div class="home">
        <div class="summary">
            <span>
                GENEasso: A Curated Resource of Credible Disease-Gene Associations Across Complex Diseases from GWAS Summary Statistics
            </span>
        </div>

        <!-- <div class="search-box">
            <t-select
                v-model="searchId"
                @search="handleSearch"
                @focus="handleInputFocus"
                :options="searchOption"
                class="search-all"
                placeholder="eg: lung cancer, TP53, ENSG00000141510"
            />
            <div @click="handleClickSearch"><i class="fas fa-search" style="cursor: pointer;"></i></div>
        </div> -->

        <div class="stock-box">
            <a class="stock-box-item" v-for="item in titleList" :key="item.label" :href="item.url" >
                <p>{{ item.label }}</p>
            </a>
        </div>
        <br />
        <!-- <div class="stock-box1" >
            <a class="stock-box-item" v-for="item in titleList2" :key="item.label" :href="item.url" >
                <p>{{ item.label }}</p>
            </a>
        </div> -->
        <div style="display: flex; align-items: center; justify-content: center;">
            <img src="/images/home1.png" style="width: 80%; "  />
        </div>

        <div class="desc-box">
            <div class="desc-item">
                <div class="title">About GENEasso</div>
                <div class="content">
                    <p>Welcome to GENEasso – an interactive, curated database of disease-gene associations derived from population-scale GWAS summary statistics.</p>
                    <p>The GENEasso database module integrates 8,226 high-quality curated GWAS datasets and identifies over 700,000 significant disease-gene associations using seven widely used gene-based association methods (twelve models in total). Each association is supported by method-specific statistics and replication metrics across populations and sample sizes.</p>
                    <p>Users can browse associations by gene or disease, filter by population, method, or significance, and download complete datasets. Interactive visualizations, including Manhattan plots and detailed result tables, make data exploration intuitive and accessible.</p>
                    <p>The accompanying analysis module allows researchers to upload their own GWAS summary statistics and run integrated gene-based association pipelines online—without the need for complex software installations. GENEasso also estimates tissue-specific relevance, helping identify credible biological mechanisms behind disease risk.</p>
                    <p>Whether you are exploring candidate genes for functional validation or comparing results across studies, GENEasso provides a comprehensive, user-friendly resource for post-GWAS analysis.</p>
                </div>
            </div>
        </div>
        <div class="desc-box">
            <div class="desc-item">
                <div class="title">Feedback & Contact</div>
                <div class="content">
                    For any inquiries, comments, or feedback regarding GENEasso, please contact Prof. Chen Cao at caochen@njmu.edu.cn or Prof. Ning Gu at guning@nju.edu.cn.
                </div>
            </div>
        </div>
        <!-- <div class="desc-box">
            <div class="desc-item">
                <div class="title">Latest Updates</div>
                <div class="content">
                    <ul class="infinite-list" v-infinite-scroll="load" style="overflow:auto; height: 100px;">
                        <li>2023-6-21 GENEasso 1.3 release (Increased the number of GWAS Summary Statistics Data to 8,903).</li>
                        <li>2023-6-5 GENEasso 1.2 release (Integrated CWAS & RWAS methods).</li>
                        <li>2023-6-1 GENEasso 1.1 release (Integrated interactive Manhattan plot in GENEasso).</li>
                        <li>2023-5-19: Bug fixes.</li>
                        <li>2023-4-13: GENEasso 1.0 release.</li>
                    </ul>
                </div>
            </div>
        </div> -->
        <div class="desc-box">
            <div class="desc-item">
                <div class="title">Licenses</div>
                <div class="content">
                    GENEasso is available free of charge for all users, including both academic and commercial users.
                </div>
            </div>
        </div>

        <!--
        <div class="new-box">
            <div class="new-item">
                <div class="new-title">Latest News</div>
                <p>
                    TWAS Atlas version 1.0 was online on 2022-05-15 and knowledge graph was
                    constructed with curated associations
                </p>
            </div>
            <div class="new-item">
                <div class="new-title">Citation and Contact</div>
                <p>
                    TWAS Atlas version 1.0 was online on 2022-05-15 and knowledge graph was
                    constructed with curated associations
                </p>
            </div>
        </div>
        -->
    </div>
</template>

<script>
const titleList = [
    {
        label: "Disease",
        value: "8,903",
        key: "associationCount",
        url: '/#/browseTraits'
    },
    {
        label: "Gene",
        value: "8,903",
        key: "associationCount",
        url: '/#/browseGenes'
    },
    {
        label: "Search",
        value: "8,903",
        key: "associationCount",
        url: '/#/search'
    },
    {
        label: "Downloads",
        value: "8,903",
        key: "associationCount",
        url: '/#/downloads'
    },
    {
        label: "Analysis",
        value: "8,903",
        key: "associationCount",
        url: '/#/twas'
    },
];

const titleList2 = [
    {
        label: "Analysis & Comparison",
        value: "8,903",
        key: "associationCount",
        url: '/#/twas'
    },
    {
        label: "Trait-specific Tissue Calculation",
        value: "795,393",
        key: "traitCount",
        url: '/#/tissue'
    }
];

export default {
    name: "Home",
    components: {},
    data() {
        return {
            titleList,
            titleList2,
            searchId: "",
            searchOption: [],
        };
    },
    created() {

    },

    methods: {
        handleClickSearch() {
            if (!this.searchId) return;

            let item = this.searchOption.find(v => v.value === this.searchId);
            const urlMap = {
                trait: "trait",
                gene: "genedetail",
                publication: "publication",
                snp: "snp",
            };

            this.$router.push({
                name: urlMap[item.type],
                params: {
                    id: item.id,
                }
            });
        },
        async handleSearch(val) {
            let params = {
                keyword: val,
                pageSize: 20,
            };
            let res = await this.$ajax.get("/trait/search", params);

            this.searchOption = (res.data.records || []).map((v) => {
                return {
                    ...v,
                    label: v.name,
                    value: v.id,
                };
            });
        },

        handleInputFocus() {},

        // async getHomeInfo() {
        //     let res = await this.$ajax.get("/statistics/home");
        //     const data = res.data;
        //     this.titleList.forEach((item) => {
        //         item.value = data[item.key] || 0;
        //     });
        // },
    },
};
</script>

<style lang="less" scoped>
.home {
    margin: 80px auto 60px;
    width: 85%;
}

.summary {
    margin-top: 15px;
    margin-bottom: 30px;
    font-size: 24px;
    line-height: 1.8;
    text-align: justify;
}

.stock-box {
    display: grid;
    grid-template-columns: repeat(5, 20%);
    grid-template-rows: 160px;
    .stock-box-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        color: #ffffff;
        text-align: center;
        font-size: 24px;
        font-weight: bold;
        line-height: 1.6;
        background: #2a6240;
        text-decoration: none;

        &:nth-child(2n) {
            color: #268483;
            background: #fffaeb;
        }
    }
}

.stock-box1 {
    display: grid;
    grid-template-columns: repeat(2, 50%);
    grid-template-rows: 160px;
    .stock-box-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        color: #ffffff;
        text-align: center;
        font-size: 24px;
        font-weight: bold;
        line-height: 1.6;
        background: #2a6240;
        text-decoration: none;

        &:nth-child(2n) {
            color: #268483;
            background: #fffaeb;
        }
    }
}

.new-box {
    display: flex;
    justify-content: space-between;
    margin-top: 60px;

    .new-item {
        height: 200px;
        width: calc(50% - 50px);
        border: 1px solid #dddddd;

        .new-title {
            padding: 15px 15px;
            text-align: center;
            font-size: 20px;
            font-weight: bold;
            background: #f5f5f5;
        }
    }
}

.desc-box {
    display: flex;
    justify-content: space-between;
    margin: 50px 0;

    .desc-item {
        width: 100%;
        padding: 0 20px;
        &:not(:last-child) {
            border-right: 1px solid #be4a81;
        }
        .title {
            color: #007c82;
            margin-bottom: 16px;
            text-align: center;
            font-size: 28px;
        }

        .content {
            font-size: 20px;
        }
    }
}

.img-box {
    display: flex;
    justify-content: space-evenly;

    img {
        width: 150px;
    }
}

.search-box {
    position: relative;
    i {
        position: absolute;
        top: 50%;
        right: 5px;
        transform: translate(0, -50%);
        font-size: 24px;
    }
}

.search-all {
    margin-bottom: 30px;

    &.t-select {
        /deep/ .select-input {
            &::after {
                display: none;
            }
        }
    }
}
</style>
